//USER ACTION TYPES

export interface GetUserInfoAction {
	type: typeof GET_USER_INFO;
	payload;
	success;
	failed;
}
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_INFO_ERROR = 'GET_USER_INFO_ERROR';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';

export interface SignUpUserAction {
	type: typeof SIGN_UP_USER;
	payload;
	success;
	failed;
}

export const SIGN_UP_USER = 'SIGN_UP_USER';
export const SIGN_UP_USER_ERROR = 'SIGN_UP_USER_ERROR';
export const SIGN_UP_USER_SUCCESS = 'SIGN_UP_USER_SUCCESS';

export interface UpdateProfileAction {
	type: typeof UPDATE_PROFILE;
	payload;
	success;
	failed;
}

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';

export interface DeleteProfileImageAction {
	type: typeof DELETE_PROFILE_IMAGE;
	payload;
	success;
	failed;
}

export const DELETE_PROFILE_IMAGE = 'DELETE_PROFILE_IMAGE';
export const DELETE_PROFILE_IMAGE_ERROR = 'DELETE_PROFILE_IMAGE_ERROR';
export const DELETE_PROFILE_IMAGE_SUCCESS = 'DELETE_PROFILE_IMAGE_SUCCESS';
export interface UplaodProfileImageAction {
	type: typeof UPLOAD_PROFILE_IMAGE;
	payload;
	success;
	failed;
}

export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE';
export const UPLOAD_PROFILE_IMAGE_ERROR = 'UPLOAD_PROFILE_IMAGE_ERROR';
export const UPLOAD_PROFILE_IMAGE_SUCCESS = 'UPLOAD_PROFILE_IMAGE_SUCCESS';

export interface UplaodImageAction {
	type: typeof UPLOAD_IMAGE;
	payload;
	success;
	failed;
}

export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';

export interface DeleteImageAction {
	type: typeof DELETE_IMAGE;
	payload;
	success;
	failed;
}

export const DELETE_IMAGE = 'DELETE_IMAGE';
export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';

export interface SignInUserAction {
	type: typeof SIGN_IN_USER;
	payload;
	success;
	failed;
}

export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGN_IN_USER_ERROR = 'SIGN_IN_USER_ERROR';
export const SIGN_IN_USER_SUCCESS = 'SIGN_IN_USER_SUCCESS';

export interface AddSocialMediaAction {
	type: typeof ADD_SOCIAL_MEDIA;
	payload;
	success;
	failed;
}

export const ADD_SOCIAL_MEDIA = 'ADD_SOCIAL_MEDIA';
export const ADD_SOCIAL_MEDIA_ERROR = 'ADD_SOCIAL_MEDIA_ERROR';
export const ADD_SOCIAL_MEDIA_SUCCESS = 'ADD_SOCIAL_MEDIA_SUCCESS';
export interface RemoveSocialMediaAction {
	type: typeof REMOVE_SOCIAL_MEDIA;
	payload;
	success;
	failed;
}

export const REMOVE_SOCIAL_MEDIA = 'REMOVE_SOCIAL_MEDIA';
export const REMOVE_SOCIAL_MEDIA_ERROR = 'REMOVE_SOCIAL_MEDIA_ERROR';
export const REMOVE_SOCIAL_MEDIA_SUCCESS = 'REMOVE_SOCIAL_MEDIA_SUCCESS';
export interface RemoveLinkAction {
	type: typeof REMOVE_LINK;
	payload;
	success;
	failed;
}

export const REMOVE_LINK = 'REMOVE_LINK';
export const REMOVE_LINK_ERROR = 'REMOVE_LINK_ERROR';
export const REMOVE_LINK_SUCCESS = 'REMOVE_LINK_SUCCESS';

export interface RemovePhotoAction {
	type: typeof REMOVE_PHOTO;
	payload;
	success;
	failed;
}

export const REMOVE_PHOTO = 'REMOVE_PHOTO';
export const REMOVE_PHOTO_ERROR = 'REMOVE_PHOTO_ERROR';
export const REMOVE_PHOTO_SUCCESS = 'REMOVE_PHOTO_SUCCESS';
export interface AddAchievementsAction {
	type: typeof ADD_ACHIEVEMENTS;
	payload;
	success;
	failed;
}

export const ADD_ACHIEVEMENTS = 'ADD_ACHIEVEMENTS';
export const ADD_ACHIEVEMENTS_ERROR = 'ADD_ACHIEVEMENTS_ERROR';
export const ADD_ACHIEVEMENTS_SUCCESS = 'ADD_ACHIEVEMENTS_SUCCESS';

export interface RemoveAchievementAction {
	type: typeof REMOVE_ACHIEVEMENT;
	payload;
	success;
	failed;
}

export const REMOVE_ACHIEVEMENT = 'REMOVE_ACHIEVEMENT';
export const REMOVE_ACHIEVEMENT_ERROR = 'REMOVE_ACHIEVEMENT_ERROR';
export const REMOVE_ACHIEVEMENT_SUCCESS = 'REMOVE_ACHIEVEMENT_SUCCESS';

export interface AddLinksAction {
	type: typeof ADD_LINKS;
	payload;
	success;
	failed;
}

export const ADD_LINKS = 'ADD_LINKS';
export const ADD_LINKS_ERROR = 'ADD_LINKS_ERROR';
export const ADD_LINKS_SUCCESS = 'ADD_LINKS_SUCCESS';
export interface UploadImageLinksAction {
	type: typeof ADD_LINKS;
	payload;
	success;
	failed;
}
export const UPLOAD_IMAGE_LINKS = 'UPLOAD_IMAGE_LINKS';
export const UPLOAD_IMAGE_LINKS_ERROR = 'UPLOAD_IMAGE_LINKS_ERROR';
export const UPLOAD_IMAGE_LINKS_SUCCESS = 'UPLOAD_IMAGE_LINKS_SUCCESS';
export interface AddPhotossAction {
	type: typeof ADD_PHOTOS;
	payload;
	success;
	failed;
}

export interface RemoveUserAction {
	type: typeof REMOVE_USER;
	payload;
	success;
	failed;
}

export const REMOVE_USER = 'REMOVE_USER';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';

export const ADD_PHOTOS = 'ADD_PHOTOS';
export const ADD_PHOTOS_ERROR = 'ADD_PHOTOS_ERROR';
export const ADD_PHOTOS_SUCCESS = 'ADD_PHOTOS_SUCCESS';

export const INIT_FORM = 'INIT_FORM';
export const ADD_FORM_DATA = 'ADD_FORM_DATA';
export const RESET_FORM_DATA = 'RESET_FORM_DATA';
export const SET_REQUEST_ERROR = 'SET_REQUEST_ERROR';
export const INIT_SOCIAL_FORM = 'INIT_SOCIAL_FORM';
export const ADD_SOCIAL_FORM_DATA = 'ADD_SOCIAL_FORM_DATA';

export const RESET_AUTH_DATA = 'RESET_AUTH_DATA';

export const SHOW_DIALOG = 'SHOW_DIALOG';
export const DISMISS_DIALOG = 'DISMISS_DIALOG';

export const SHOW_MODAL = 'SHOW_MODAL';
export const DISMISS_MODAL = 'DISMISS_MODAL';
